<template>
    <div class="form-group">
        <span v-if="required" class="text-danger">*</span>
        <label :for="$attrs.id">
            {{label}}
        </label>
        <textarea class="form-control" rows="5" v-if="!disabled" v-bind="$attrs" :value="value" @paste="onPaste" @input="$emit('input', $event.target.value)"></textarea>
        <textarea class="form-control" rows="5" disabled v-else :value="value"></textarea>
    </div>
</template>

<script>
    export default {
        name: 'formTextarea',
        inheritAttrs: false,
        props: ['value', 'label'],
        computed: {
            required: function () {
                return this.$attrs.required === "" || this.$attrs.required === true;
            },
            disabled: function () {
                return this.$attrs.disabled === "" || this.$attrs.disabled === true;
            },
        },
        methods: {
            onPaste(event) {
                // Prevent the default paste behavior
                event.preventDefault();

                // Get the pasted content
                const pastedContent = event.clipboardData.getData('text/plain');

                // Split the pasted content into an array of lines
                const lines = pastedContent.split('\n');

                // Apply the regular expression to all lines except the first one
                const filteredLines = lines.map((line, index) => {
                if (index === 0) {
                    // Keep the first line as is
                    return line;
                } else {
                    // Filter out Unicode characters from the second line onwards
                    return line.replace(/[\u007f-\uffff]/g, '');
                }
                });

                // Join the filtered lines back into a string
                const filteredContent = filteredLines.join('\n');

                // Set the filtered value as the value of the textarea
                event.target.value = filteredContent;

                // Emit an input event with the filtered value
                this.$emit('input', event.target.value);
            }
        }
    };
</script>

<style>
</style>